import { utils } from 'pixi.js';

export enum MapActions {
    LEVEL_SELECT = 'add currency',
    CHEST_SELECT = 'show popup',
}

export class MapEmitter extends utils.EventEmitter {
    private static instanceCache: MapEmitter;

    static get instance(): MapEmitter {
        if (!this.instanceCache) {
            this.instanceCache = new MapEmitter();
        }
        return this.instanceCache;
    }

    constructor() {
        super();
    }
}
